


export default {
    install(Vue, option) {
        Vue.prototype.$validate = new (function () {
            const DataValid = function (data) {
                if (data !== undefined && data !== null && data !== '') {
                    if (typeof data === 'object') {
                        return Object.keys(data).length > 0
                    } else if (Array.isArray(data)) {
                        return data.length > 0
                    }

                    if (data.length > 0) {
                        return data.trim().length > 0
                    }
                    return true;

                } else {
                    return false
                }
            }

            const regex = {
                email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                // phone: /^[2-9][0-9]{7}$/,
                phone: /^(\+?)[0-9]{2,18}$/i,
                hkMobile: /^[3-9][0-9]{7}$/,
                number: /^[0-9]+$/i,
                // floating: /^[0-9]+([.]?[0-9]{1,2})?$/i,
                floating: /^[0-9]+([.]?[0-9]{1})?$/i,
                floatingWithoutLimit: /^[0-9]+([.]?[0-9]+)?$/i,
                negativeNumber: /^[-]?[0-9]+$/i,
                negativeFloating: /^[-]?[0-9]+([.]?[0-9]+)?$/i,
                // blogSlug: /^[a-zA-Z0-9-_]+$/i
                blogSlug: /^[\u4e00-\u9fff\u3400-\u4dff\uf900-\ufaffA-za-z0-9-_]+$/i,
                hkid4Letter: /^[A-Z]{1,2}[0-9]{4}$/,
                date: /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
                regexIdNum: /^[a-zA-Z0-9]{8,9}$/i,
                hkPhone: /^(^[2|3|4|5|6|7|8|9])+([0-9]{7})$/,
                twPhone: /^(^[1-9])+([0-9]{8})$/,
                macauPhone: /^([0-9]{8})$/,
                chinaPhone: /^(^[1])+([0-9]{10})$/,
                chinName: /^[\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u017F\u3400-\u4DBF\u4E00-\u9FFF]{2,40}$/,
                engName: /^[a-zA-Z\s.]{2,40}$/,
                password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
                styleCode: /^[aAsSbBlLxX][0-9]{4}$/,
            }

            this.DataValid = data => {
                return DataValid(data);
            }

            this.required = value => {
                if (DataValid(value) && typeof value === 'string') {
                    return value.trim().length > 0
                }

                return DataValid(value);
            }

            this.regexNumber = (value) => {
                return regex.number.test(value);
            }

            this.regexFloating = (value) => {
                return regex.floatingWithoutLimit.test(value);
            }

            this.regexDateStr = (value) => {
                const valid = regex.date.test(value);
                if (!valid) {
                    return false;
                }

                const month = parseInt(value.substring(5, 7));
                if (month < 1 || month > 12) {
                    return false;
                }

                const daysInMonths = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                const date = parseInt(value.substring(8, 10));

                if (date < 1 || date > daysInMonths[month - 1]) {
                    return false;
                }

                return true;
            }

            this.isNumber = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'Required';
                    }
                }

                return regex.number.test(value) || 'Incorrect format'
            }

            this.isFloating = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'Required';
                    }
                }

                return regex.floating.test(value) || 'Incorrect format'
            }

            this.isPhoneNumber = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'Required';
                    }
                }

                return regex.phone.test(value) || 'Incorrect format'
            }

            this.isFaxNumber = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'Required';
                    }
                }

                return regex.number.test(value) || 'Incorrect format'
            }

            this.isEmail = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'Required';
                    }
                }

                return regex.email.test(value) || 'Incorrect format'
            }

            this.isEngName = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'Required';
                    }
                }

                return regex.engName.test(value) || 'Incorrect format'
            }

            this.isChinName = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'Required';
                    }
                }

                return regex.chinName.test(value) || 'Incorrect format'
            }

            this.isUrlSlug = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'Required';
                    }
                }

                return regex.blogSlug.test(value) || 'Only Chinese characters, A-Z, a-z, 0-9, underscore (_) and hyphen (-) can be entered.'
            }


            this.isValidPassword = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'Required';
                    }
                }

                return true;
                // return regex.password.test(value) || '請輸入最少8個英文或數字字元作為密碼'
            }

            this.checkDoubleFileExtension = (fileName) => {
                const extension = fileName.match(/\.(.+)$/)[1];

                if (extension.split(".").length !== 1) {
                    return true;
                }

                return false;
            }

            this.validateFileInput = (file, requiredExtension, maxSize = 20) => {
                // requiredType = img, video...
                // requiredExtension = png, jpg, mp4...

                const limitFileSize = maxSize;

                let result = '';
                const fileType = file.type;
                let format = '';

                switch (fileType) {
                    case 'application/msword':
                        format = 'doc'
                        break
                    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                        format = 'docx'
                        break
                    case 'application/vnd.ms-excel':
                        format = 'xls'
                        break
                    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                        format = 'xlsx'
                        break
                    case 'application/vnd.ms-powerpoint':
                        format = 'ppt'
                        break
                    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                        format = 'pptx'
                        break
                    case 'text/plain':
                        format = 'txt'
                        break
                    case 'image/svg+xml':
                        format = 'svg'
                        break
                    default:
                        format = fileType.split('/')[1]
                        break
                }



                if (this.checkDoubleFileExtension(file.name)) {
                    result = 'The filename should NOT include symbol "."';
                } else if (!requiredExtension.includes('*') && !requiredExtension.includes(format)) {
                    result = `Only file format in ${requiredExtension.join(', ')} can be uploaded`;
                } else if (file.size / 1000 / 1000 > limitFileSize) {
                    result = `File size should not exceed ${limitFileSize}MB`;
                }

                return result;
            }
        })()
    }
}